import { render, staticRenderFns } from "./ImportantData.vue?vue&type=template&id=3b66967f"
import script from "./ImportantData.vue?vue&type=script&lang=js"
export * from "./ImportantData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports